import api from './api';

export interface User {
  id: string;
  wallet_address: string;
  email?: string;
  role: 'issuer' | 'investor' | 'admin';
  kyc_status: 'pending' | 'approved' | 'rejected';
  created_at?: string;
}

export interface CreateUserRequest {
  wallet_address: string;
  email?: string;
  role: 'issuer' | 'investor' | 'admin';
}

export const userService = {
  // Create user (for new wallet connections)
  async createUser(data: CreateUserRequest): Promise<User> {
    console.log('Creating user with data:', data);
    try {
      const response = await api.post('/users', data);
      console.log('User created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to create user:', error);
      throw error;
    }
  },

  // Get user by wallet address
  async getUserByWallet(walletAddress: string): Promise<User> {
    console.log('Getting user by wallet address:', walletAddress);
    try {
      const response = await api.get(`/users/wallet/${walletAddress}`);
      console.log('User found by wallet:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to get user by wallet:', error);
      throw error;
    }
  },

  // Get user by ID
  async getUser(userId: string): Promise<User> {
    console.log('Getting user by ID:', userId);
    try {
      const response = await api.get(`/users/${userId}`);
      console.log('User found by ID:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to get user by ID:', error);
      throw error;
    }
  },

  // Logout (client-side only)
  logout(): void {
    console.log('Logging out user');
    localStorage.removeItem('authToken');
  },
}; 